import { render, staticRenderFns } from "./test-portal-data-capture-forms.vue?vue&type=template&id=b01afd80&"
import script from "./test-portal-data-capture-forms.vue?vue&type=script&lang=js&"
export * from "./test-portal-data-capture-forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-data-capture-forms.vue"
export default component.exports